export const MAX_CHAR_LIMITS = {
  CATEGORY_TEXT: 50,
  CATEGORY_TEXTAREA: 75,
  CATEGORY_TEXTMSG: 100,
};
const messageStyle = { fontSize: "12px",  marginTop:"6px", color:"#6F7171" };
export const getCharLimitMsgIfExceeded = (fieldKey, value) => {
  const limit = MAX_CHAR_LIMITS[fieldKey]-1;
  if (!limit || !value || value.length <= limit) return null;
  return (
    <p style={messageStyle}>
     Maximum characters: {limit+1}
    </p>
  );
};
export const getCharLimitMsgDeviceProfile = (fieldKey, value) => {
  const limit = MAX_CHAR_LIMITS[fieldKey]-1;
  if (!limit || !value || value.length <= limit) return null;
  return (
    `Maximum characters: ${limit+1}`
  );
};
